import React from 'react'
import Table from '../../../../common/components/table'

 
export default function WebsitePageComponents ({setPageData,paginationData,additionButtons,rowData,columnDefs,onEdit}: any) {
  return (
    <>

<Table
    columnData={columnDefs}
    rowData={rowData}
    onEdit={onEdit}
    additionButtons={additionButtons}
    headingName="Pages"
    setPageData={setPageData}
    paginationData={paginationData}
    />
                   
 
   
        </>
  )
}